import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { FaqAPI } from '../api/faq/faqapi';
import { FaqRequest } from '../api/faq/faqrequest';
import { FaqResponse } from '../api/faq/faqresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { FaqAPIProcessorImpl } from '../processor/faqapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';

export class FaqProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(FaqProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getFaqDetails():APIProcessor<FaqRequest, FaqResponse>
    {
        this.logger.log("getFaqDetails() invoked");
        return new FaqAPIProcessorImpl(this.getContext(), new FaqAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/faqprocessorfactory.tsx